import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Badge,
  Breadcrumb,
  Button,
  Form,
  OverlayTrigger,
  Table,
  Tooltip
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {
  BiSearch,
  BiSort
} from "react-icons/bi";
import { BsEye } from "react-icons/bs";
import { FcFinePrint } from "react-icons/fc";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import Pagination from "../../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  FORM_BUILDER_LISTING_URL,
  LIST_DEF_SORT,
  LS_ACCESS_TOKEN_KEY,
  SORT_ORDER_DESC,
  STATUS
} from "../../../../core/constants/common";
import DataCollectionEventService from "../../../../core/service/DataCollectionEventService";
import FormService from "../../../../core/service/FormService";
import Utils from "../../../../core/utilities/Utils";
import "./MatForms.scss";

function MatAssessmentSubmissionList({ t }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const { self } = useParams();

  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [searchKey, setSearchKey] = useState("");
  const [forms, setForms] = useState([]);
  const [formsQual, setFormsQual] = useState([]);
  const location = useLocation();
  const authToken = localStorage.getItem(LS_ACCESS_TOKEN_KEY);
  const currentRoute = window.location.pathname;
  const assessmentName = location.state?.assessmentName ?? '';
  const qualitativeDataStatus = location.state?.qual ?? ''

  useEffect(() => {
    id && getSubmissions(0, itemsPerPage, searchKey, sortField);
    qualitativeDataStatus && id && getSubmissionsQual(0, itemsPerPage)
  }, [id]);


  const getSubmissionsQual = (pageNumber, itemsPerPageVal) => {
    let perPage = '';
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    

    DataCollectionEventService.getShareDetails(id,
      pageNumber,
      perPage,
    ).then((response) => {
      const totalPages = parseFloat(response.headers["x-total-count"]);
      setItemTotalCount(totalPages);
      setFormsQual([...response.data]);
    })
      .catch((error) => {
      });
  };
  const getSubmissions = (pageNumber, itemsPerPageVal, key = "", sortField, orderVal = null) => {
    if (qualitativeDataStatus) {
      return
    }
    let perPage = '';
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    // Use provided orderVal or fall back to state
    const sortOrder = orderVal !== null ? orderVal : order;
    let sort = sortField + "," + sortOrder;
    FormService.getSubmissions(
      id,
      pageNumber,
      perPage,
      sort,
      key,
    ).then((response) => {
      const totalPages = parseFloat(response.headers["x-total-count"]);
      setItemTotalCount(totalPages);
      setForms([...response.data]);
    })
      .catch((error) => {
      });
  };

  const handleSort = (val) => {
    const newOrder = sortField === val && order === "asc" ? "desc" : "asc";
    setOrder(newOrder);
    setSortField(val);
    // Use the new value (val) and newOrder to ensure correct sorting
    getSubmissions(0, itemsPerPage, searchKey, val, newOrder);
  };

  const handleSearch = (val) => {
    setSearchKey(val);
    getSubmissions(0, itemsPerPage, val, sortField);
  };
  const viewSubmission = (action, formId = "", sId, key) => {
    const formType = "ASSESSMENT";
    const hasPermission = null;
    const string = Utils.generateUrlParamFormCreate(
      action,
      authToken,
      formType,
      0,
      formId,
      key,
      sId,
      hasPermission,
      { route: currentRoute, fid: formId }
    );
    const encodedDat = Utils.encodeBase64(string);
    window.location.href = FORM_BUILDER_LISTING_URL + `/?q=${encodedDat}`;
  };

  const getAssessmentTitle = () => {
    if (assessmentName) {
      // Prevent ReDoS: use safer extraction method
      if (typeof assessmentName === 'string' && assessmentName.length <= 500) {
        // Extract first 4 digits using match() - safer than replace with backtracking regex
        const match = assessmentName.match(/\d{4}/);
        return match ? match[0] : assessmentName;
      }
      return assessmentName;
    }

    return `${forms[0]?.form?.name} - ${moment(forms[0]?.assessment?.period).format("MMMM, YYYY")}`;
  };

  const renderStatusBadge = (item) => {
    if (item.tokenStatus === 'REVOKED') {
      return (
        <Badge bg="badge-Rejected">
          {STATUS['NO_PERMISSION']}
        </Badge>
      );
    }
    switch (item.status) {
      case "IN_PROGRESS":
        return (
          <Badge bg="badge-Draft">
            {STATUS[item.status]}
          </Badge>
        );
      case "COMPLETED":
        return (
          <Badge bg="badge-Published">
            {STATUS[item.status]}
          </Badge>
        );
      case "DRAFT":
        return (
          <Badge bg="badge-New">
            {STATUS['NOT_STARTED']}
          </Badge>
        );
      default:
        return (
          <Badge bg="badge-New">
            {STATUS[item.status]}
          </Badge>
        );
    }
  };
  
  return (
    <>
      <div className="FormsList">
        <div className="List_header">
          <Breadcrumb className="h5">
            <Breadcrumb.Item onClick={() => {
              navigate(`/company_admin/dmat/stats`)
            }} > {t("Materiality.label")}</Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(`/company_admin/dmat/matassessments`,
              { state: { isQualitative: qualitativeDataStatus ? true : false } }
            )}>{t("Surveys.label")}</Breadcrumb.Item>
            <Breadcrumb.Item active> {getAssessmentTitle()} - {t("Responses.label")}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="List_Table_01">
          <div className="List_table-card01_head">
            <ul>
              <li>
                <div className="List_table-card_Search_01">
                  <div className="List_table-card_Search_Box">
                    <Form>
                      <input
                        type="text"
                        className="form-control"
                        value={searchKey}
                        onChange={(e) => handleSearch(e.target.value)}
                        placeholder={t("SearchByName.label")}
                      />
                      <a className="Search_iocnBox cursor" onClick={() => handleSearch(searchKey)}>
                        <BiSearch />
                      </a>
                    </Form>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="card List_table-card01">

            {qualitativeDataStatus ?
              <Table responsive="sm">
                <thead>
                  <tr>
                    {<th>{t('Users.label')}</th>}
                    <th>{t("SharedDate.label")}</th>
                    <th>{t("LastModified.label")}</th>
                    <th>{t("Status.label")}</th>
                  </tr>
                </thead>
                <tbody>
                  {formsQual.length > 0 ? (
                    formsQual.map((item, index) => (
                      <tr key={item.id}>
                        <td>{item.user.name}</td>
                        <td>{moment(item.sharedOn).format("MMMM DD, YYYY")}</td>
                        <td>{item.lastModifiedDate ? moment(item.sharedOn).format("MMMM DD, YYYY") : ''}</td>
                        <td>
                        {
                          item.lastModifiedDate === null
                          ?
                          <span className="badge bg-badge-New rounded-pill">{t("NotStarted.label")}</span>
                          :
                          item.progressCount['COMPLETED'] === item.progressCount['TOTAL']
                          ?        
                          <span className="badge bg-badge-Finalized rounded-pill">{t("Completed.label")}</span>      
                          : 
                          <span className="badge bg-badge-Inprogress rounded-pill">{t("InProgress.label")}</span>
                        }
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        <div className="Nodatafound_box">
                          <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              :
              <Table responsive="sm">
                <thead>
                  <tr>
                    <th>{t('StakeholderGroup.label')}</th>
                    <th>{t('StakeHolders.label')}</th>
                    <th>{t("SharedDate.label")}</th>
                    <th>{t("ExpiryDate.label")}</th>
                    <th>
                      <Link to="#" onClick={() => handleSort("status")}>
                        {t("Status.label")}
                        <BiSort />
                      </Link>
                    </th>
                    <th>
                      <Link to="#" onClick={() => handleSort("lastModifiedDate")}>
                        {t("SubmittedDate.label")}
                        <BiSort />
                      </Link>
                    </th>
                    <th>

                    </th>
                  </tr>
                </thead>
                <tbody>
                  {forms.length > 0 ? (
                    forms.map((item, index) => (
                        <tr key={item.submissionId}>
                          <td>{item.stakeholder?.name ?? 'NA'}</td>
                          <td>{item.stakeholder?.sharedEmail ?? 'NA'}</td>
                          <td>{item.assessment?.sharedOn ? moment(item.assessment?.sharedOn).format("MMMM DD, YYYY") : ''}</td>
                          <td>
                            {
                              item.assessment?.lastSubmissionDate
                                ?
                                <>
                                  {moment(item.assessment?.lastSubmissionDate).format("MMMM DD, YYYY")}&nbsp;
                                </>
                                : ''
                            }
                          </td>
                          <td>{renderStatusBadge(item)}</td>
                          <td>
                            {item.submissionDate
                              ? moment(item.submissionDate).format(
                                "MMM DD, YYYY , h:mm:ss a"
                              )
                              : "-"}
                          </td>
                          <td>
                            {
                              item.tokenStatus !== 'REVOKED' &&
                              <OverlayTrigger
                                placement="auto"
                                overlay={<Tooltip id="tooltip-like">{t("ViewesponseToolTip.label")}</Tooltip>} >
                                <Button
                                  variant="blank_outline"
                                  onClick={() => viewSubmission(
                                    "SUBMIT",
                                    item.form.id,
                                    item.submissionId,
                                    item.token
                                  )}>
                                  <BsEye />
                                </Button>
                              </OverlayTrigger>
                            }
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        <div className="Nodatafound_box">
                          <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>}
            {qualitativeDataStatus ?
              <div className="p-2 List_footer_count">
                <Pagination
                  itemsTotalCount={itemsTotalCount}
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  alwaysShown={true}
                  setItemsPerPage={setItemsPerPage}
                  pageClicked={(pageNum, perPage) => {
                    getSubmissionsQual(pageNum, perPage);
                  }}
                />
              </div>
              :
              <div className="p-2 List_footer_count">
                <Pagination
                  itemsTotalCount={itemsTotalCount}
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  alwaysShown={true}
                  setItemsPerPage={setItemsPerPage}
                  pageClicked={(pageNum, perPage) => {
                    getSubmissions(pageNum, perPage, searchKey, sortField);
                  }}
                />
              </div>
            }

          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(MatAssessmentSubmissionList);
